import { PrescriptionModel } from './../../../models/master-data/prescription.model';
import { PrescribeVaccinationComponent } from './../prescribe-vaccination/prescribe-vaccination.component';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { Utility } from '../../../common/utility';
import { PrescriptionsModel } from '../../../models/consultation-process/prescription-selection.model';
import { Observable } from 'rxjs/Observable';
import { PrescriptionUrl } from '../../../shared/urls/master-data.prescription.url';
import { PrescriptionCategoryUrl } from '../../../shared/urls/master-data.prescription-category.url';

@Injectable()
export class PrescriptionsModule {
  constructor(private baseService: BaseService) {

  }

  getConsultationPrescriptions(consultationId): any {
    let url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_PRESCRIPTION, [consultationId]);
    return this.baseService.getData(url);
  }

  getPrescriptionsCategories(): any {
    let url = PrescriptionCategoryUrl.PRESCRIPTIONCATEGORY_GET_ALL;
    return this.baseService.getData(url);
  }

  getPrescriptions(categoryId): any {
    let url = PrescriptionUrl.PRESCRIPTION_GET_ALL.replace('{0}', categoryId);
    return this.baseService.getData(url, { isHasPrice: true });
  }

  updatePrescriptions(consultationId, data, isMoveNextStep, isFromConsultationHistory = false) {
    let url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_PRESCRIPTION, [consultationId]);
    url += '?isMoveNextStep=' + isMoveNextStep;
    if (isFromConsultationHistory) {
      url += "&isFromConsultationHistory=" + isFromConsultationHistory;
    }
    return this.baseService.postData(url, data);
  }

  quickSearchPrescriptions(searchKey, showPinner = true) {
    const url = PrescriptionUrl.PRESCRIPTION_GET_BY_NAME;
    return this.baseService.getData(url, { name: searchKey, isHasPrice: true }, showPinner);
  }
}
;



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/select-prescriptions/select-prescriptions.service.ts